import { computed, Injectable, signal } from '@angular/core';
import { jwtDecode } from 'jwt-decode';


@Injectable({
  providedIn: 'root'
})
export class TokenTimerService {
  private remainingTime = signal<number>(0);

  constructor() {
    this.startTime();
  }

  private startTime(): void {
    const token = this.getToken();
    if(!token) {
      this.remainingTime.set(0);
      return;
    }
    
    const decoded = jwtDecode(token);
    const exp = decoded.exp;
    const expirationTime = exp! * 1000;
    
    const timer = setInterval(() => {
      const now = Date.now();
      const remaining = expirationTime - now;
      // console.log('=> ', remaining)
      this.remainingTime.set(Math.max(remaining, 0));
      if (remaining <= 0) clearInterval(timer);
    }, 60 * 1000);
  }
  
  private getToken() {
    return sessionStorage.getItem('access_token');
  }
  
  getMainingTime = computed(() => {
    const ms = this.remainingTime();
    const minutes = Math.floor(ms / (60 * 1000));
    return minutes;
  });

}
